import React, { useState, useEffect } from 'react';
import { letteraIntentoService } from '../services/api';
import { LetteraIntento } from '../models/types';
import './LettereIntentoPage.css';

const LettereIntentoPage: React.FC = () => {
  const [lettere, setLettere] = useState<LetteraIntento[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadLettere();
  }, []);

  const loadLettere = async () => {
    try {
      setLoading(true);
      const data = await letteraIntentoService.getAll();
      setLettere(data);
      setError(null);
    } catch (err) {
      setError('Errore durante il caricamento delle lettere d\'intento');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Caricamento lettere d'intento...</div>;
  }

  if (error) {
    return (
      <div className="error">
        <p>{error}</p>
        <button className="btn btn-primary" onClick={loadLettere}>
          Riprova
        </button>
      </div>
    );
  }

  return (
    <div className="lettere-page">
      <div className="page-header">
        <h1>?? Lettere d'Intento</h1>
        <button className="btn btn-primary" onClick={loadLettere}>
          Aggiorna
        </button>
      </div>

      {lettere.length === 0 ? (
        <div className="empty-state">
          <p>Nessuna lettera d'intento trovata</p>
        </div>
      ) : (
        <div className="card">
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Protocollo</th>
                <th>Data Emissione</th>
                <th>Data Scadenza</th>
                <th>Cliente</th>
                <th>Plafond</th>
                <th>Utilizzato</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              {lettere.map((lettera) => (
                <tr key={lettera.id}>
                  <td>{lettera.id}</td>
                  <td>{lettera.protocollo}</td>
                  <td>{new Date(lettera.dataEmissione).toLocaleDateString('it-IT')}</td>
                  <td>{new Date(lettera.dataScadenza).toLocaleDateString('it-IT')}</td>
                  <td>{lettera.cliente}</td>
                  <td>� {lettera.plafond.toFixed(2)}</td>
                  <td>� {lettera.utilizzato.toFixed(2)}</td>
                  <td>
                    <span className={`status status-${lettera.stato.toLowerCase()}`}>
                      {lettera.stato}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default LettereIntentoPage;
